import "../chunk-KEWTJQOK.mjs";
import {
  useBlogList
} from "../chunk-ELRMLU5N.mjs";
import "../chunk-FOJMTK4I.mjs";
import "../chunk-FXLMWHDY.mjs";
import {
  useVerifyHyCoupon
} from "../chunk-N5RJAENB.mjs";
import "../chunk-BKWZJPJV.mjs";
import {
  useGetExperiencesByCategory
} from "../chunk-2AYKQOOV.mjs";
import {
  useGetExperienceBySlug
} from "../chunk-R3FAAFC5.mjs";
import "../chunk-7CPUYQCC.mjs";
import {
  useShopProducts
} from "../chunk-CLOXJZKV.mjs";
import "../chunk-2UHM253B.mjs";
import "../chunk-6M5H4JB4.mjs";
import {
  useRechargeWallet
} from "../chunk-J4GGO4L7.mjs";
import {
  useGetTransactionById,
  useGetTransactionByPaymentSessionId
} from "../chunk-USJMOH2U.mjs";
import {
  useGetUserWallets
} from "../chunk-GVTBIL6U.mjs";
import "../chunk-5QKEYGOP.mjs";
import {
  useGetVoucherPaymentDetails
} from "../chunk-IURBFBI2.mjs";
import {
  useGetUserVouchers
} from "../chunk-NCBVPQXF.mjs";
import {
  useGetVouchers
} from "../chunk-LJYLULBF.mjs";
import {
  useGetBanks
} from "../chunk-YARLFQUL.mjs";
import {
  useClaimWithOtp
} from "../chunk-DYJW3F3R.mjs";
import {
  useGetWalletHistory
} from "../chunk-THSQ5F2O.mjs";
import "../chunk-EQMFSDPZ.mjs";
import {
  useAddToThirdPartCart
} from "../chunk-DHXBJLF6.mjs";
import {
  useInitThirdPartCart
} from "../chunk-FD2WSDM7.mjs";
import {
  useRemoveFromThirdPartCart
} from "../chunk-FDZOTUES.mjs";
import "../chunk-QD2YOJOV.mjs";
import {
  useGetTournamentTeamsBySlug
} from "../chunk-PPWED34B.mjs";
import {
  useGetTournamentDetails
} from "../chunk-7EJDHDBB.mjs";
import {
  useGetTournamentEventsBySlug
} from "../chunk-NLC72OXC.mjs";
import {
  useGetTournamentOrganizationsBySlug
} from "../chunk-46FRKRAW.mjs";
import "../chunk-O5EKO7IJ.mjs";
import {
  useAnswerSurvey
} from "../chunk-SZ3HDQ5V.mjs";
import {
  useGetSurvey
} from "../chunk-RHD5OSF5.mjs";
import "../chunk-G445A56D.mjs";
import {
  useGetTeamEvents
} from "../chunk-HJWHRAKY.mjs";
import {
  useGetTeamsList
} from "../chunk-LVOKEVPK.mjs";
import {
  useGetTeam
} from "../chunk-7OVL7N5I.mjs";
import "../chunk-5JSYNTRB.mjs";
import "../chunk-ODHGRMV4.mjs";
import {
  useGetSubscriptionById,
  useGetUserSubscriptions
} from "../chunk-YKKEAOL2.mjs";
import {
  useGetSubscriptionActions
} from "../chunk-CFSCR34C.mjs";
import {
  useGetBillingHistory
} from "../chunk-DU2JB6ZD.mjs";
import {
  useCancelSubscription
} from "../chunk-HBKYUF2F.mjs";
import {
  useCheckoutStreamWithCredit,
  useCheckoutSubscription
} from "../chunk-2ZRTYFJC.mjs";
import {
  useGetSubscriptions
} from "../chunk-EWTCJTIE.mjs";
import {
  useGetSubscriptionPlans
} from "../chunk-ID5FPV5V.mjs";
import "../chunk-5T46NBCZ.mjs";
import {
  useSubscribeSaudiRewards
} from "../chunk-OLJZR3HR.mjs";
import {
  useVerifySaudiRewards
} from "../chunk-BYIABUWX.mjs";
import "../chunk-2TLKOXBL.mjs";
import {
  useGetAccessibilitySeason,
  useGetSeason
} from "../chunk-MHZ4XSJZ.mjs";
import {
  useGetSeasonPerks
} from "../chunk-DZZXJU32.mjs";
import {
  useGetReservedSeats
} from "../chunk-QT2KAFRK.mjs";
import {
  useGetHoldToken
} from "../chunk-Z64GIK7P.mjs";
import "../chunk-4SJVSJPB.mjs";
import {
  useRegisterCompetition
} from "../chunk-QJFPNTXK.mjs";
import "../chunk-UXPONVQK.mjs";
import {
  useReportSuspiciousActivity
} from "../chunk-MT6KECVX.mjs";
import {
  useSubmitFanProtection
} from "../chunk-MGYQ332C.mjs";
import {
  useClaimSaudiRewards
} from "../chunk-FT5VVUQ7.mjs";
import "../chunk-D3YLNXL6.mjs";
import {
  useGetEventResaleTickets,
  useGetResaleListing
} from "../chunk-VOOQTJVT.mjs";
import {
  useGetResaleInformation
} from "../chunk-MPCKF52R.mjs";
import {
  useGetResaleMultipliers
} from "../chunk-IUQVUZFS.mjs";
import {
  useSetTicketsForResale
} from "../chunk-SY54UEWQ.mjs";
import {
  useGetUserResaleListing
} from "../chunk-INIL4QLO.mjs";
import "../chunk-YHJGQ5NE.mjs";
import {
  useServmeShifts
} from "../chunk-ANKYWNRG.mjs";
import {
  useSevenRoomsTables
} from "../chunk-A77B5R2P.mjs";
import {
  useEatappAvailability,
  useSevenRoomsAvailability
} from "../chunk-ATEIJD6J.mjs";
import "../chunk-I6RQ6EFT.mjs";
import {
  useSubmitAnswers
} from "../chunk-6L3AE7LG.mjs";
import {
  useGetQuestionnaireFields
} from "../chunk-USRJXPCX.mjs";
import "../chunk-Z2W2HXAY.mjs";
import {
  useRefundPolicies
} from "../chunk-IXMIAU7L.mjs";
import "../chunk-A6P6NDN7.mjs";
import {
  useEventRequest,
  useGetEventRequest
} from "../chunk-UN7WL4AS.mjs";
import "../chunk-JA5I5RHY.mjs";
import {
  useSendPartnerOtp,
  useVerifyPartnerOtp
} from "../chunk-KZ6Q2EUK.mjs";
import {
  useResetPartnerUserPassword,
  useVerifyPartnerPasswordResetToken
} from "../chunk-TY6TFVXQ.mjs";
import {
  useValidatePartnerEnc
} from "../chunk-O3PBDR2Z.mjs";
import "../chunk-PCI3A3DY.mjs";
import {
  useGetPaymentMethods
} from "../chunk-V6XR4JCF.mjs";
import "../chunk-S2JMW6YP.mjs";
import {
  useSendQitafOtp
} from "../chunk-V2DPLQG4.mjs";
import {
  useRedeemQitaf
} from "../chunk-B5L6VU4U.mjs";
import "../chunk-G7BCRYVW.mjs";
import {
  useSubscribe
} from "../chunk-PSGCVUWB.mjs";
import "../chunk-KQROKQHP.mjs";
import {
  useGetOrganizationBySlug
} from "../chunk-F6KX6LGZ.mjs";
import {
  useGetOrganizationCheckoutInfo
} from "../chunk-HZI6PKHO.mjs";
import {
  useGetOrganizations,
  useGetOrganizationsHasVouchers
} from "../chunk-67U3R75R.mjs";
import "../chunk-3NAM65ON.mjs";
import {
  useGetTicketingPackage
} from "../chunk-XLNLAS5B.mjs";
import "../chunk-UIH4ZQUF.mjs";
import {
  useSendMokafaaOtp
} from "../chunk-JANY656X.mjs";
import {
  useRedeemMokafaaToWallet
} from "../chunk-UEGEXMNB.mjs";
import "../chunk-7HR4YN4U.mjs";
import {
  useCheckNafath
} from "../chunk-SRBRYZ4E.mjs";
import {
  useRequestNafath
} from "../chunk-PC7UAMXT.mjs";
import "../chunk-LG63ZOVM.mjs";
import {
  useGetNews,
  useGetNewsBySlug
} from "../chunk-CWXYNOJ7.mjs";
import "../chunk-XS73KS6W.mjs";
import {
  useCreateMediaAccreditation
} from "../chunk-UZM6ENOZ.mjs";
import "../chunk-77XNBFDO.mjs";
import {
  useHoldProducts
} from "../chunk-AV2ASXVT.mjs";
import {
  useMerchandiseProducts
} from "../chunk-W2KWZGZI.mjs";
import {
  useGetMerchandiseProduct
} from "../chunk-3SGGMXVV.mjs";
import {
  useCalculateShippingFees
} from "../chunk-UYATIUYQ.mjs";
import "../chunk-3ZYQH5VR.mjs";
import {
  useTicketInterest
} from "../chunk-JUTVATC4.mjs";
import {
  useGetInterests
} from "../chunk-MYWUKUTB.mjs";
import {
  useRegisterInterest
} from "../chunk-45MTMAMD.mjs";
import "../chunk-Z4PLY7ZV.mjs";
import {
  useGetHotelReservation,
  useGetHotelReservations
} from "../chunk-ZWWNFPRT.mjs";
import {
  useGetHotelsResults,
  useGetHotelsResultsByIds
} from "../chunk-6B5CZFPZ.mjs";
import {
  useGetHotelReviews
} from "../chunk-OT6PTAGW.mjs";
import {
  useModifySearch,
  useSearchHotels,
  useSearchHotelsByPlaceIds
} from "../chunk-M7WCFMXR.mjs";
import {
  useSelectedPackage
} from "../chunk-UQM5OYQ2.mjs";
import {
  useHotelsCheckout
} from "../chunk-5FOMJIAL.mjs";
import {
  useGetHotelDetails,
  useGetRoomDetails
} from "../chunk-AYLCPVYF.mjs";
import {
  useDownloadHotelInvoice
} from "../chunk-34NQGNIV.mjs";
import {
  useLocations,
  usePopularLocations
} from "../chunk-7TWLQ2RW.mjs";
import {
  useGetLocationNotice
} from "../chunk-AL7DKNF7.mjs";
import {
  useGetPackageId,
  useGetPackageResults
} from "../chunk-R3BHQPQ4.mjs";
import "../chunk-2LHFK2NZ.mjs";
import {
  useGeoLocation
} from "../chunk-HSLZQDY2.mjs";
import "../chunk-7J3IKFZ3.mjs";
import {
  useDownloadInvoice
} from "../chunk-HZN7WYOD.mjs";
import {
  useGetFlightOrder,
  useGetFlightsOrders
} from "../chunk-DXTXFUBN.mjs";
import {
  useCreatePassenger,
  useDeletePassenger,
  useGetAllPassengers,
  useGetPassenger,
  useUpdatePassenger
} from "../chunk-QLP3CSLD.mjs";
import {
  useReserveFlight
} from "../chunk-EGMQJGVJ.mjs";
import {
  useFareRules
} from "../chunk-Y4KQO56A.mjs";
import {
  useGetInboundFlights,
  useGetOutboundFlights,
  useSearchFlights
} from "../chunk-DV2ZWE4W.mjs";
import {
  useSelectedFlight
} from "../chunk-X7QBN6JW.mjs";
import {
  useAirports,
  useNearestAirport,
  usePopularAirports
} from "../chunk-VCG4ZA6Z.mjs";
import {
  useFlightsCheckout
} from "../chunk-4ZRZTUY2.mjs";
import {
  useFareFamilies
} from "../chunk-KXKYLYPZ.mjs";
import "../chunk-6FSQB6YV.mjs";
import {
  useGetFaqsGroups
} from "../chunk-IZOMMMXK.mjs";
import {
  useGetFaqByGroup,
  useGetFaqsList
} from "../chunk-2M5JVQDL.mjs";
import "../chunk-GKZ57MZB.mjs";
import {
  useUpdateFavoriteTeam
} from "../chunk-B2XL4PMO.mjs";
import {
  useToggleUserFavorite
} from "../chunk-D7DU4UJN.mjs";
import {
  useUpdateUserInterests
} from "../chunk-XTEL7RIO.mjs";
import {
  useGetUserFavorites
} from "../chunk-LYIJAAMS.mjs";
import {
  useGetFavoriteEvent
} from "../chunk-QW7SNOXS.mjs";
import {
  useGetInterestOptions
} from "../chunk-NPFTKRUW.mjs";
import "../chunk-AMNMJOKG.mjs";
import {
  useGetEvisaOrder,
  useResubmitEvisaOrder
} from "../chunk-GLDXYHIE.mjs";
import {
  useAddEVisaTraveler,
  useCorrectEVisaTraveler,
  useDeleteEVisaTraveler,
  useGetEVisaTravelers,
  useUpdateEVisaTraveler
} from "../chunk-RQ7OYOSV.mjs";
import {
  useCreateEVisaApplication,
  useGetEVisaApplication,
  useGetEVisaApplications
} from "../chunk-SIULSQX7.mjs";
import {
  useCheckoutEVisaStandalone
} from "../chunk-EMP2FJIU.mjs";
import {
  useGetEVisaStandaloneEligibility
} from "../chunk-PWQCHYDD.mjs";
import {
  useDownloadEvisaInvoice
} from "../chunk-6U2JHTXC.mjs";
import {
  useGetEVisaLookups
} from "../chunk-F6II7VAH.mjs";
import {
  useScanEVisaPassport
} from "../chunk-HBFEZBUY.mjs";
import "../chunk-WDZEJEHT.mjs";
import {
  useGetVenues
} from "../chunk-H6HMU54E.mjs";
import {
  useGetEventPrerequisiteTickets
} from "../chunk-RO572SYF.mjs";
import {
  useGetEventsGroupDetails
} from "../chunk-SFQBXT27.mjs";
import {
  useEventsList,
  useEventsListByOrganizationSlug,
  useOrganizationsEvents,
  usePaginatedEventsList
} from "../chunk-RH6CIZNU.mjs";
import {
  useGetTicketPackagesEligibility
} from "../chunk-MB6S57E4.mjs";
import {
  useGetEventPerks
} from "../chunk-QCASTN25.mjs";
import {
  useGetEventQuestions
} from "../chunk-F3NO7UB6.mjs";
import {
  useGetTickets
} from "../chunk-3USAXJ77.mjs";
import {
  useGetCheckoutInfo
} from "../chunk-LPA7DY3V.mjs";
import {
  useGetEventCrossSelling
} from "../chunk-6WMVZDW4.mjs";
import {
  useGetEventDeals
} from "../chunk-KN4KLMAK.mjs";
import {
  useGetTicketingEventBlacklist
} from "../chunk-C4G2Y372.mjs";
import {
  useGetAccessibilityTicketingEvent,
  useGetTicketingEvent
} from "../chunk-2FYM5JU6.mjs";
import {
  useGetEventGroupBySlug
} from "../chunk-2JON2JRY.mjs";
import {
  useGetUserEventLimits
} from "../chunk-UNT6PTR6.mjs";
import {
  useGetAccessibilityTicketingEventSlots,
  useGetTicketingEventSlots
} from "../chunk-6DU5YECQ.mjs";
import "../chunk-X7CUQC4Y.mjs";
import {
  useGetSupportedCurrencies
} from "../chunk-AKXOIQKD.mjs";
import "../chunk-XUTYQBME.mjs";
import {
  useActivateDevice
} from "../chunk-6YAU5ZBC.mjs";
import {
  useGetEventAddonsById
} from "../chunk-54YBBXT5.mjs";
import "../chunk-VMXRLYQB.mjs";
import {
  useGetCruisesPorts
} from "../chunk-Y4KLLQJ3.mjs";
import {
  useSearchCruises
} from "../chunk-Y622U4WA.mjs";
import {
  useCreateTraveller,
  useDeleteTraveller,
  useGetAllTravellers,
  useGetTraveller,
  useUpdateTraveller
} from "../chunk-7CROPDE5.mjs";
import {
  useGetBookingSummary
} from "../chunk-FQD442RN.mjs";
import {
  useGetAllCabins
} from "../chunk-U266TDCX.mjs";
import {
  useGetCruiseCabinCategories,
  useSelectCruiseCabinCategories
} from "../chunk-LZODKWLW.mjs";
import {
  useGetCruisesDestinations
} from "../chunk-BF42DINT.mjs";
import {
  useGetCruiseDetail
} from "../chunk-YE5REI5K.mjs";
import {
  useDownloadCruiseInvoice
} from "../chunk-FINC6AQ3.mjs";
import {
  useGetAllCruisesOrderDetails,
  useGetCruiseOrderDetails
} from "../chunk-6L5ZNNNB.mjs";
import "../chunk-RJ7PV2AC.mjs";
import {
  useContactUs
} from "../chunk-AEWSU6BU.mjs";
import "../chunk-NGR77FSJ.mjs";
import {
  useVerifyCoupon
} from "../chunk-LZ4F4RGD.mjs";
import "../chunk-6VWZBF3E.mjs";
import {
  useCourtAvailableDates
} from "../chunk-O2NOUKVP.mjs";
import {
  useCourtDurations
} from "../chunk-KCJEZLDE.mjs";
import {
  useCourtSlots
} from "../chunk-SNVH2VEB.mjs";
import "../chunk-FSCAG4CK.mjs";
import {
  useAddToCart
} from "../chunk-LTWGIROV.mjs";
import {
  useGetCartItems
} from "../chunk-OZYKRDIC.mjs";
import {
  useCheckoutCart
} from "../chunk-453TSCFQ.mjs";
import {
  useRemoveCartItem
} from "../chunk-Q7R3DITL.mjs";
import {
  useRemoveAllCartItems
} from "../chunk-F4HKUDSM.mjs";
import "../chunk-VPROHC3W.mjs";
import {
  useGetCities,
  useGetPaginatedCities
} from "../chunk-JH4FWPTD.mjs";
import "../chunk-YW7P3I26.mjs";
import {
  useGetDigitalCardById
} from "../chunk-C75WRERR.mjs";
import {
  useGetDigitalCards
} from "../chunk-JO6EGEWR.mjs";
import {
  useTopUpQuote
} from "../chunk-YUQ73VWG.mjs";
import {
  useTopUpCard
} from "../chunk-W6ZVARQO.mjs";
import {
  useGetTopUpTransactionbyId
} from "../chunk-5CSGKPVQ.mjs";
import {
  useGetUserDigitalCardById
} from "../chunk-YEWGR2BO.mjs";
import {
  useGetUserDigitalCards
} from "../chunk-O7AKR5B3.mjs";
import "../chunk-XPXHANYB.mjs";
import {
  useGetMarketingFees
} from "../chunk-ETZEJRBI.mjs";
import {
  useGetHyExperienceOrderById,
  useGetOrderById
} from "../chunk-BMNYDU2C.mjs";
import {
  useVerifyPnr
} from "../chunk-HHUF7TZZ.mjs";
import {
  useAssignOrderSeats,
  useGetAssignSeatsData
} from "../chunk-VYRRGQIC.mjs";
import {
  useGetUserBookingById
} from "../chunk-KCT2T564.mjs";
import "../chunk-JJDHBOQ6.mjs";
import {
  useBusiness
} from "../chunk-O6QJLW7A.mjs";
import {
  useApplePayPaymentProceed,
  useApplePayPaymentSession
} from "../chunk-5HBJLKE7.mjs";
import {
  useGetBluBookings,
  useGetBookings,
  useGetHyExperiencesBookings,
  useGetSeasonBookings
} from "../chunk-7C4NVO3A.mjs";
import {
  useClaimOfflineOrder,
  useClaimOfflineOrderAndUpdateUser,
  useValidateOfflineOrderToken
} from "../chunk-OH5YNQWN.mjs";
import {
  useDownloadReceipt,
  useDownloadTicket
} from "../chunk-6PUFBWMA.mjs";
import {
  useSendOtpToFanId,
  useVerifyFanIdOtp
} from "../chunk-T4B42WYI.mjs";
import {
  useGetGeneratedPayment
} from "../chunk-6DD26BYE.mjs";
import {
  useDeleteAccount
} from "../chunk-TALBLHV2.mjs";
import {
  useGetTawakkalnaUser,
  useLinkTawakkalnaUser
} from "../chunk-BKACMKGN.mjs";
import {
  useGetUser
} from "../chunk-LUMF4NRH.mjs";
import {
  useChangePassword,
  useForgotPassword,
  useUpdatePassword
} from "../chunk-NE6F5GH7.mjs";
import {
  useUpdateProfile
} from "../chunk-QTJXRDIX.mjs";
import {
  useRefreshTokens
} from "../chunk-OBUJDSDQ.mjs";
import {
  useRegister,
  useSignup
} from "../chunk-X4TNUDNX.mjs";
import {
  useResetPasswordWithToken,
  useVerifyPasswordResetToken
} from "../chunk-PJWMMOV7.mjs";
import {
  useSocialEnabled
} from "../chunk-NYDH6MLS.mjs";
import {
  useValidateSocialLogin
} from "../chunk-VLPFPR4B.mjs";
import {
  useSsoLogin
} from "../chunk-ANQPTITG.mjs";
import {
  useCheckEmail,
  useSendOtpToEmail,
  useUpdateEmail,
  useVerifyEmail
} from "../chunk-J2LUZ6WJ.mjs";
import {
  useLogin
} from "../chunk-6CHSVKNM.mjs";
import {
  useLogout
} from "../chunk-LERXOQNA.mjs";
import {
  useResendOtp,
  useSendOtp,
  useVerifyOtp
} from "../chunk-7KC7R4NL.mjs";
import "../chunk-U5ODFYVI.mjs";
import {
  useRequestDisabilityTickets
} from "../chunk-EHH33FDG.mjs";
import {
  useUpdateAccessibilityRequest
} from "../chunk-52BCSZMN.mjs";
import {
  useViewRequest
} from "../chunk-WV5EK2WV.mjs";
import "../chunk-ND5RCKP6.mjs";
import {
  useGetAuctionOrders
} from "../chunk-ZAJDJHWM.mjs";
import {
  useCheckoutAuctionPayment,
  useGetAuctionPaymentDetails
} from "../chunk-4O2Y5NMA.mjs";
import {
  useGetAuctionSecureDeposit
} from "../chunk-JNWGTVWR.mjs";
import {
  useAddAddress
} from "../chunk-GQ3EDTWO.mjs";
import {
  useGetAuctionHistory
} from "../chunk-AS7SX3T6.mjs";
import {
  useDidUserJoinedAuction
} from "../chunk-VPHVQ5KC.mjs";
import {
  useCancelAccessibilityRequest
} from "../chunk-27EUUSDD.mjs";
import {
  useCreateAccessibilityRequest
} from "../chunk-YNIYZCFS.mjs";
import {
  useGetAccessibilityRequests
} from "../chunk-YGCV3NRZ.mjs";
import "../chunk-7PIOR77R.mjs";
import "../chunk-PLZ2AG7M.mjs";
import "../chunk-YAFEA4GV.mjs";
import "../chunk-OTZHFFCM.mjs";
import "../chunk-CBIK6ZLK.mjs";
import "../chunk-SDFEMQUB.mjs";
import "../chunk-E34LUH6G.mjs";
import "../chunk-NMBT7PIE.mjs";
import "../chunk-OT34EGZO.mjs";
import "../chunk-RJXNRUBT.mjs";
import "../chunk-FOJHN6HD.mjs";
import "../chunk-JPI4FPBP.mjs";
import "../chunk-OICAFEXO.mjs";
import "../chunk-YWTSVXV6.mjs";
import "../chunk-KPRDG7DR.mjs";
import "../chunk-5TTMZXSY.mjs";
import "../chunk-LPVQMOLH.mjs";
import "../chunk-QCC5BX2R.mjs";
import "../chunk-T5MLJCOQ.mjs";
import "../chunk-K57AIL3V.mjs";
import "../chunk-HHHZGDI5.mjs";
import "../chunk-BPKVWIQD.mjs";
import "../chunk-C7BX5OMA.mjs";
import "../chunk-E6AUSYWH.mjs";
import "../chunk-IL34TLOI.mjs";
import "../chunk-DEJ436V5.mjs";
import "../chunk-IY346L2T.mjs";
import "../chunk-FGJKLRNV.mjs";
import "../chunk-ZAYVOYWA.mjs";
import "../chunk-S5TFWWY6.mjs";
import "../chunk-GDNRMQJ7.mjs";
import "../chunk-VMNJ5CUA.mjs";
import "../chunk-VEILD7LK.mjs";
import "../chunk-BBO5TLVZ.mjs";
import "../chunk-RCOUC4UY.mjs";
import "../chunk-ZPHO6NW6.mjs";
import "../chunk-TRVOCNJ2.mjs";
import "../chunk-L4Q4YEMJ.mjs";
import "../chunk-ICBCJ4TF.mjs";
import "../chunk-HUR6HGBY.mjs";
import "../chunk-I4ZRAKBV.mjs";
import "../chunk-JBSN4ZZ6.mjs";
import "../chunk-47V255NO.mjs";
import "../chunk-2EU6QDUA.mjs";
import "../chunk-WPQ4LM42.mjs";
import "../chunk-5US3DELL.mjs";
import "../chunk-TWP3HMCX.mjs";
import "../chunk-XIPRKMNB.mjs";
import "../chunk-4WXYMJKJ.mjs";
import "../chunk-GVWMWYRB.mjs";
import "../chunk-EEOWZMYK.mjs";
import "../chunk-OTEMO3EQ.mjs";
import "../chunk-25RNMCEN.mjs";
import "../chunk-A4ATQWYG.mjs";
import "../chunk-EK5C4BKB.mjs";
import "../chunk-56U2C5RE.mjs";
import "../chunk-NVBAX2YY.mjs";
import "../chunk-26KZWBKD.mjs";
import "../chunk-ITAFKKRB.mjs";
import "../chunk-4I4WOQZP.mjs";
import "../chunk-GT6BEZA2.mjs";
import "../chunk-N6LR4NJZ.mjs";
import "../chunk-SOKGFAGF.mjs";
import "../chunk-TOMFDAX3.mjs";
import "../chunk-WYEY6B67.mjs";
import "../chunk-VFWGUQ6E.mjs";
import "../chunk-EW3JJYGP.mjs";
import "../chunk-YHJAGYFE.mjs";
import "../chunk-76WIWZUC.mjs";
import "../chunk-AQVRCWFO.mjs";
import "../chunk-6B2O37AE.mjs";
import "../chunk-WKI5B7WG.mjs";
import "../chunk-PBFGYFR4.mjs";
import "../chunk-TEFJUF7U.mjs";
import "../chunk-HPDY2XCK.mjs";
import "../chunk-4T2V63G2.mjs";
import "../chunk-CBSCKXJI.mjs";
import "../chunk-MBCBWSB2.mjs";
import "../chunk-SJ62XX5G.mjs";
import "../chunk-EIVAXUP4.mjs";
import "../chunk-FT4HDSZ7.mjs";
import "../chunk-VJMEZCND.mjs";
import "../chunk-6IONBTU2.mjs";
import "../chunk-EMRLLOIH.mjs";
import "../chunk-4SAODAZX.mjs";
import "../chunk-MJUL5X4M.mjs";
import "../chunk-CKB2GWR5.mjs";
import "../chunk-2EW6PRHF.mjs";
import "../chunk-AKCRQSCS.mjs";
import "../chunk-YJRK7R47.mjs";
import "../chunk-46H5CFYA.mjs";
import "../chunk-MMNYWAKZ.mjs";
import "../chunk-OPNG72H7.mjs";
import "../chunk-X3UAIIIL.mjs";
import "../chunk-SAJLN2Y4.mjs";
import "../chunk-CIE4FB47.mjs";
import "../chunk-HE64LB42.mjs";
import "../chunk-ARVDX26K.mjs";
import "../chunk-EUDA44QJ.mjs";
import "../chunk-MAN34AVI.mjs";
import "../chunk-6JOGWVGS.mjs";
import "../chunk-JI5U5XIQ.mjs";
import "../chunk-W6AJTTKQ.mjs";
import "../chunk-2FHLRP6W.mjs";
import "../chunk-QS4UHVNQ.mjs";
import "../chunk-VBWQAXWO.mjs";
import "../chunk-PY4DVTRO.mjs";
import "../chunk-5AZN4VUL.mjs";
import "../chunk-447J5VLV.mjs";
import "../chunk-2THTUX6I.mjs";
import "../chunk-ONLVRAHT.mjs";
import "../chunk-IMYUV2BR.mjs";
import "../chunk-NHKTCJIG.mjs";
import "../chunk-4UJBENPR.mjs";
import "../chunk-ELHJGQDJ.mjs";
import "../chunk-SCSVVTYL.mjs";
import "../chunk-WRA7LYCV.mjs";
import "../chunk-W5YPA4JJ.mjs";
import "../chunk-L3TFUH4M.mjs";
import "../chunk-DKGFFL7T.mjs";
import "../chunk-NJKOXMTT.mjs";
import "../chunk-SWF7BDLB.mjs";
import "../chunk-E4GRLBUM.mjs";
import "../chunk-3VZ2XOY3.mjs";
import "../chunk-QBVVRT6K.mjs";
import "../chunk-DAMPQ3BX.mjs";
import "../chunk-JVXFQU2S.mjs";
import "../chunk-SOVP4M7S.mjs";
import "../chunk-VGUTQDXY.mjs";
import "../chunk-IJHXSJGM.mjs";
import "../chunk-2JNTSJDE.mjs";
import "../chunk-SYNJB5SY.mjs";
import "../chunk-5DSPOACP.mjs";
import "../chunk-5VHPMUB6.mjs";
import "../chunk-CDFP2POK.mjs";
import "../chunk-PQCBWSBP.mjs";
import "../chunk-IU7DLKAG.mjs";
import "../chunk-Z3JXDCQ4.mjs";
import "../chunk-MP72B7O4.mjs";
import "../chunk-RI2LQNNH.mjs";
import "../chunk-5TOJXEQI.mjs";
import "../chunk-SHGA3SNV.mjs";
import "../chunk-LCVR74BA.mjs";
import "../chunk-3DAVMVMQ.mjs";
import "../chunk-XT3T7HYI.mjs";
import "../chunk-DG6TRNHS.mjs";
import "../chunk-WMR5QC7Q.mjs";
import "../chunk-IP5GBGHB.mjs";
import "../chunk-56QEENOZ.mjs";
import "../chunk-TWAFXFNR.mjs";
import "../chunk-BRA6RZKS.mjs";
import "../chunk-D2OT7Z4O.mjs";
import "../chunk-45SLKW4N.mjs";
import "../chunk-4BBRBLML.mjs";
import "../chunk-MMLXG4CU.mjs";
import "../chunk-BP3FBSRS.mjs";
import "../chunk-RU7JTQG6.mjs";
import "../chunk-ZBZZBB6U.mjs";
import "../chunk-77XUGTO7.mjs";
import "../chunk-BEVX52C3.mjs";
import "../chunk-HTLLDS6V.mjs";
import "../chunk-QZ373GB7.mjs";
import "../chunk-GNEMQR2P.mjs";
import "../chunk-TOY73C7L.mjs";
import "../chunk-YGIL6ABQ.mjs";
import "../chunk-KIXZ7N37.mjs";
import "../chunk-NTBN4WKW.mjs";
import "../chunk-N6A4JYLM.mjs";
import "../chunk-VVUEFUKX.mjs";
import "../chunk-L37AQEOO.mjs";
import "../chunk-ZB2ZB4QU.mjs";
import "../chunk-AIITMJMT.mjs";
import "../chunk-P4HT4TD5.mjs";
import "../chunk-23V3YWBC.mjs";
import "../chunk-KERMTD33.mjs";
import "../chunk-QXDVPTFY.mjs";
import "../chunk-HRUKHPSP.mjs";
import "../chunk-XPVDQGJY.mjs";
import "../chunk-65F7VT6H.mjs";
import "../chunk-JIEDK6EQ.mjs";
import "../chunk-BZYX5ZCL.mjs";
import "../chunk-UCUJCN7S.mjs";
import "../chunk-447VRYE2.mjs";
import "../chunk-4HBFV4EV.mjs";
import "../chunk-5SHSYTKC.mjs";
import "../chunk-NDWV2QOA.mjs";
import "../chunk-UY6IDS3N.mjs";
import "../chunk-PPNPKURF.mjs";
import "../chunk-QQQ24EF2.mjs";
import "../chunk-OVZ7EZQN.mjs";
import "../chunk-YYOVFKHI.mjs";
import "../chunk-VSEIEBAZ.mjs";
import "../chunk-KXT7E3BR.mjs";
import "../chunk-RAF24QGU.mjs";
import "../chunk-ZOAHQ2MQ.mjs";
import "../chunk-XWLWPM4C.mjs";
import "../chunk-PYA3XA7F.mjs";
import "../chunk-H3QMZNUD.mjs";
import "../chunk-QUIXPXRE.mjs";
import "../chunk-NMQF22EZ.mjs";
import "../chunk-DI4F3YUF.mjs";
import "../chunk-UTHY44KE.mjs";
import "../chunk-HSA6GNMK.mjs";
import "../chunk-ZJYF4UXN.mjs";
import "../chunk-KSN6NPSV.mjs";
import "../chunk-J6GJ4BMZ.mjs";
import "../chunk-IAGVRP5D.mjs";
import "../chunk-YAL52MWB.mjs";
import "../chunk-CBM7IRMX.mjs";
import "../chunk-SE7GFET2.mjs";
import "../chunk-ONLAXWGW.mjs";
import "../chunk-M2CSVYVL.mjs";
import "../chunk-OJSSDWZS.mjs";
import "../chunk-UHKASGR3.mjs";
import "../chunk-KZWR6JV7.mjs";
import "../chunk-I4HLEM4H.mjs";
import "../chunk-HTWSEE2Y.mjs";
import "../chunk-MQP34X4O.mjs";
import "../chunk-GTS2KJIH.mjs";
import "../chunk-QKQLTMQ7.mjs";
import "../chunk-GDUUOCQ2.mjs";
import "../chunk-DHRSHMB2.mjs";
import "../chunk-FVF2SMHA.mjs";
import "../chunk-FRQRMYBL.mjs";
import "../chunk-FM76CYXU.mjs";
import "../chunk-MILZ6BWO.mjs";
import "../chunk-2V3JM2LL.mjs";
import "../chunk-PV5KIJUU.mjs";
import "../chunk-PHKP2MEV.mjs";
import "../chunk-IGEK7YQ4.mjs";
import "../chunk-R5LKNTSU.mjs";
import "../chunk-CH4GUT2K.mjs";
import "../chunk-7WJR7DOJ.mjs";
import "../chunk-BY62G55C.mjs";
import "../chunk-CRMIBCMV.mjs";
import "../chunk-FBZC7XFF.mjs";
import "../chunk-MPYCCYPG.mjs";
import "../chunk-WONW7MGR.mjs";
import "../chunk-4VUOEB4Z.mjs";
import "../chunk-7QCWKQSI.mjs";
import "../chunk-DDUZ5T57.mjs";
import "../chunk-MX4NFJQQ.mjs";
import "../chunk-DXMEPHIN.mjs";
import "../chunk-FQRHG3M3.mjs";
import "../chunk-AI2UUK5E.mjs";
import "../chunk-NKCMDZP6.mjs";
import "../chunk-BQ5S3V7V.mjs";
import "../chunk-KO5WMSQM.mjs";
import "../chunk-X5VDIW6U.mjs";
import "../chunk-X3QMDGWZ.mjs";
import "../chunk-PD3HHHKH.mjs";
import "../chunk-JRUFOJMR.mjs";
import "../chunk-V7TXM5BF.mjs";
import "../chunk-ZYFQV7BW.mjs";
import "../chunk-646BUWBJ.mjs";
import "../chunk-2VR47A5Z.mjs";
import "../chunk-MII2EMYI.mjs";
import "../chunk-CZAQWXFB.mjs";
import "../chunk-L4JDHVTD.mjs";
import "../chunk-755H464A.mjs";
import "../chunk-JSJ34KJV.mjs";
import "../chunk-NT55YHQ6.mjs";
import "../chunk-BPQFN7XB.mjs";
import "../chunk-V5JCOWX7.mjs";
import "../chunk-53DGDBTW.mjs";
import "../chunk-ZMQKM2YY.mjs";
import "../chunk-P6XMZV77.mjs";
import "../chunk-DQDOOV4R.mjs";
import "../chunk-USNUKULP.mjs";
import "../chunk-KXEKEMBD.mjs";
import "../chunk-5DW6DKSR.mjs";
import "../chunk-YXIH5HR3.mjs";
import "../chunk-5DBT6SVI.mjs";
import "../chunk-XZRA6EPR.mjs";
import "../chunk-3LC557UY.mjs";
import "../chunk-SRSREVOP.mjs";
import "../chunk-Q7CFICZW.mjs";
import "../chunk-G4PMBZQY.mjs";
import "../chunk-NK43J66K.mjs";
import "../chunk-LRWTJ3DO.mjs";
import "../chunk-AKQP6RCR.mjs";
import "../chunk-7KZOUX5Z.mjs";
import "../chunk-2TYROU5Y.mjs";
import "../chunk-2I7HZRP4.mjs";
import "../chunk-4N7PY45J.mjs";
import "../chunk-TGBFL7UL.mjs";
import "../chunk-H2XINTRV.mjs";
import "../chunk-SC2QEHDD.mjs";
import "../chunk-POY332AO.mjs";
import "../chunk-TEKJC3FB.mjs";
import "../chunk-G6JPNACT.mjs";
import "../chunk-WWLG26XU.mjs";
import "../chunk-CPVMFYFD.mjs";
import "../chunk-64N4INLD.mjs";
import "../chunk-JUK2OVKG.mjs";
import "../chunk-G2X2IF27.mjs";
import "../chunk-UELQYFJ7.mjs";
import "../chunk-ZD2ESESY.mjs";
import "../chunk-G4NYY657.mjs";
import "../chunk-P2B2TNGX.mjs";
import "../chunk-JHUVX63K.mjs";
import "../chunk-IITKCRXL.mjs";
import "../chunk-RGHW4PYM.mjs";

// src/hooks/provider.tsx
import { useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { jsx, jsxs } from "react/jsx-runtime";
var localDefaults = {
  queries: {
    retry: 0,
    refetchOnWindowFocus: false
  },
  mutations: {
    retry: 0
  }
};
var QueryProvider = ({ children, defaults }) => {
  const [queryClient] = useState(
    () => new QueryClient({ defaultOptions: defaults || localDefaults })
  );
  return /* @__PURE__ */ jsxs(QueryClientProvider, { client: queryClient, children: [
    children,
    /* @__PURE__ */ jsx(ReactQueryDevtools, {})
  ] });
};
export {
  QueryProvider,
  useActivateDevice,
  useAddAddress,
  useAddEVisaTraveler,
  useAddToCart,
  useAddToThirdPartCart,
  useAirports,
  useAnswerSurvey,
  useApplePayPaymentProceed,
  useApplePayPaymentSession,
  useAssignOrderSeats,
  useBlogList,
  useBusiness,
  useCalculateShippingFees,
  useCancelAccessibilityRequest,
  useCancelSubscription,
  useChangePassword,
  useCheckEmail,
  useCheckNafath,
  useCheckoutAuctionPayment,
  useCheckoutCart,
  useCheckoutEVisaStandalone,
  useCheckoutStreamWithCredit,
  useCheckoutSubscription,
  useClaimOfflineOrder,
  useClaimOfflineOrderAndUpdateUser,
  useClaimSaudiRewards,
  useClaimWithOtp,
  useContactUs,
  useCorrectEVisaTraveler,
  useCourtAvailableDates,
  useCourtDurations,
  useCourtSlots,
  useCreateAccessibilityRequest,
  useCreateEVisaApplication,
  useCreateMediaAccreditation,
  useCreatePassenger,
  useCreateTraveller,
  useDeleteAccount,
  useDeleteEVisaTraveler,
  useDeletePassenger,
  useDeleteTraveller,
  useDidUserJoinedAuction,
  useDownloadCruiseInvoice,
  useDownloadEvisaInvoice,
  useDownloadHotelInvoice,
  useDownloadInvoice,
  useDownloadReceipt,
  useDownloadTicket,
  useEatappAvailability,
  useEventRequest,
  useEventsList,
  useEventsListByOrganizationSlug,
  useFareFamilies,
  useFareRules,
  useFlightsCheckout,
  useForgotPassword,
  useGeoLocation,
  useGetAccessibilityRequests,
  useGetAccessibilitySeason,
  useGetAccessibilityTicketingEvent,
  useGetAccessibilityTicketingEventSlots,
  useGetAllCabins,
  useGetAllCruisesOrderDetails,
  useGetAllPassengers,
  useGetAllTravellers,
  useGetAssignSeatsData,
  useGetAuctionHistory,
  useGetAuctionOrders,
  useGetAuctionPaymentDetails,
  useGetAuctionSecureDeposit,
  useGetBanks,
  useGetBillingHistory,
  useGetBluBookings,
  useGetBookingSummary,
  useGetBookings,
  useGetCartItems,
  useGetCheckoutInfo,
  useGetCities,
  useGetCruiseCabinCategories,
  useGetCruiseDetail,
  useGetCruiseOrderDetails,
  useGetCruisesDestinations,
  useGetCruisesPorts,
  useGetDigitalCardById,
  useGetDigitalCards,
  useGetEVisaApplication,
  useGetEVisaApplications,
  useGetEVisaLookups,
  useGetEVisaStandaloneEligibility,
  useGetEVisaTravelers,
  useGetEventAddonsById,
  useGetEventCrossSelling,
  useGetEventDeals,
  useGetEventGroupBySlug,
  useGetEventPerks,
  useGetEventPrerequisiteTickets,
  useGetEventQuestions,
  useGetEventRequest,
  useGetEventResaleTickets,
  useGetEventsGroupDetails,
  useGetEvisaOrder,
  useGetExperienceBySlug,
  useGetExperiencesByCategory,
  useGetFaqByGroup,
  useGetFaqsGroups,
  useGetFaqsList,
  useGetFavoriteEvent,
  useGetFlightOrder,
  useGetFlightsOrders,
  useGetGeneratedPayment,
  useGetHoldToken,
  useGetHotelDetails,
  useGetHotelReservation,
  useGetHotelReservations,
  useGetHotelReviews,
  useGetHotelsResults,
  useGetHotelsResultsByIds,
  useGetHyExperienceOrderById,
  useGetHyExperiencesBookings,
  useGetInboundFlights,
  useGetInterestOptions,
  useGetInterests,
  useGetLocationNotice,
  useGetMarketingFees,
  useGetMerchandiseProduct,
  useGetNews,
  useGetNewsBySlug,
  useGetOrderById,
  useGetOrganizationBySlug,
  useGetOrganizationCheckoutInfo,
  useGetOrganizations,
  useGetOrganizationsHasVouchers,
  useGetOutboundFlights,
  useGetPackageId,
  useGetPackageResults,
  useGetPaginatedCities,
  useGetPassenger,
  useGetPaymentMethods,
  useGetQuestionnaireFields,
  useGetResaleInformation,
  useGetResaleListing,
  useGetResaleMultipliers,
  useGetReservedSeats,
  useGetRoomDetails,
  useGetSeason,
  useGetSeasonBookings,
  useGetSeasonPerks,
  useGetSubscriptionActions,
  useGetSubscriptionById,
  useGetSubscriptionPlans,
  useGetSubscriptions,
  useGetSupportedCurrencies,
  useGetSurvey,
  useGetTawakkalnaUser,
  useGetTeam,
  useGetTeamEvents,
  useGetTeamsList,
  useGetTicketPackagesEligibility,
  useGetTicketingEvent,
  useGetTicketingEventBlacklist,
  useGetTicketingEventSlots,
  useGetTicketingPackage,
  useGetTickets,
  useGetTopUpTransactionbyId,
  useGetTournamentDetails,
  useGetTournamentEventsBySlug,
  useGetTournamentOrganizationsBySlug,
  useGetTournamentTeamsBySlug,
  useGetTransactionById,
  useGetTransactionByPaymentSessionId,
  useGetTraveller,
  useGetUser,
  useGetUserBookingById,
  useGetUserDigitalCardById,
  useGetUserDigitalCards,
  useGetUserEventLimits,
  useGetUserFavorites,
  useGetUserResaleListing,
  useGetUserSubscriptions,
  useGetUserVouchers,
  useGetUserWallets,
  useGetVenues,
  useGetVoucherPaymentDetails,
  useGetVouchers,
  useGetWalletHistory,
  useHoldProducts,
  useHotelsCheckout,
  useInitThirdPartCart,
  useLinkTawakkalnaUser,
  useLocations,
  useLogin,
  useLogout,
  useMerchandiseProducts,
  useModifySearch,
  useNearestAirport,
  useOrganizationsEvents,
  usePaginatedEventsList,
  usePopularAirports,
  usePopularLocations,
  useRechargeWallet,
  useRedeemMokafaaToWallet,
  useRedeemQitaf,
  useRefreshTokens,
  useRefundPolicies,
  useRegister,
  useRegisterCompetition,
  useRegisterInterest,
  useRemoveAllCartItems,
  useRemoveCartItem,
  useRemoveFromThirdPartCart,
  useReportSuspiciousActivity,
  useRequestDisabilityTickets,
  useRequestNafath,
  useResendOtp,
  useReserveFlight,
  useResetPartnerUserPassword,
  useResetPasswordWithToken,
  useResubmitEvisaOrder,
  useScanEVisaPassport,
  useSearchCruises,
  useSearchFlights,
  useSearchHotels,
  useSearchHotelsByPlaceIds,
  useSelectCruiseCabinCategories,
  useSelectedFlight,
  useSelectedPackage,
  useSendMokafaaOtp,
  useSendOtp,
  useSendOtpToEmail,
  useSendOtpToFanId,
  useSendPartnerOtp,
  useSendQitafOtp,
  useServmeShifts,
  useSetTicketsForResale,
  useSevenRoomsAvailability,
  useSevenRoomsTables,
  useShopProducts,
  useSignup,
  useSocialEnabled,
  useSsoLogin,
  useSubmitAnswers,
  useSubmitFanProtection,
  useSubscribe,
  useSubscribeSaudiRewards,
  useTicketInterest,
  useToggleUserFavorite,
  useTopUpCard,
  useTopUpQuote,
  useUpdateAccessibilityRequest,
  useUpdateEVisaTraveler,
  useUpdateEmail,
  useUpdateFavoriteTeam,
  useUpdatePassenger,
  useUpdatePassword,
  useUpdateProfile,
  useUpdateTraveller,
  useUpdateUserInterests,
  useValidateOfflineOrderToken,
  useValidatePartnerEnc,
  useValidateSocialLogin,
  useVerifyCoupon,
  useVerifyEmail,
  useVerifyFanIdOtp,
  useVerifyHyCoupon,
  useVerifyOtp,
  useVerifyPartnerOtp,
  useVerifyPartnerPasswordResetToken,
  useVerifyPasswordResetToken,
  useVerifyPnr,
  useVerifySaudiRewards,
  useViewRequest
};
//# sourceMappingURL=index.mjs.map